import { LimitType, PaginationInterface } from 'shared/types/swr-pagination-interface'

export const getPaginationQuery = ({
  limit,
  pagination,
  initLimit,
}: {
  limit: LimitType
  pagination: PaginationInterface
  initLimit: LimitType
}) => {
  const newQuery: Record<string, string> = {}
  if (limit !== initLimit) {
    newQuery['limit'] = limit.toString()
  }
  if (pagination.startFromId) {
    newQuery['startFromId'] = pagination.startFromId.toString()
  }
  if (pagination.order === 'prev') {
    newQuery['order'] = pagination.order
  }
  return newQuery
}
